import styled, { css } from "styled-components";

const textParagraphSmSemi = css`
  font-size: 0.875rem;
  line-height: 150%;
  font-weight: 600;
`;

const textParagraphXsRegular = css`
  font-size: 0.75rem;
  line-height: 150%;
  font-weight: 400;
`;

const textParagraphSmRegular = css`
  font-size: 0.875rem;
  line-height: 150%;
  font-weight: 400;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  ${textParagraphSmSemi}
  margin-bottom: 0.5rem;
  color: ${props => props.color || "var(--text-title, #080404)"};
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const InputField = styled.input<{ disabled?: boolean; borderColor?: string }>`
  ${textParagraphSmRegular}
  border-radius: 4px;
  border: 1px solid;
  border-color: ${props => props.borderColor || "var(--general-border, #e2e8f0)"};

  padding: 1rem;
  height: 56px;
  color: #0f172a;

  &:focus {
    outline: none;
    border-color: var(--general-border, #3754e2);
  }

  ${({ disabled }) =>
    disabled &&
    `
      opacity: 0.5;
  `}

  ::placeholder {
    color: #d1d5db;
  }
`;

export const IconWrapper = styled.div<{ position: "left" | "right" }>`
  position: absolute;
  ${({ position }) => (position === "left" ? "left: 12px;" : "right: 12px;")}
  z-index: 50;
`;

export const HelperText = styled.span`
  ${textParagraphXsRegular}
`;
